import React from 'react'

import TutorialPage from 'images/upload/tutorial.png'

import Layout from 'Pods/Profile/Layout/Layout'
import UploaderNav from 'Pods/Profile/Products/UploaderNav'

function TutorialUploader() {
  return (
    <Layout activeBreadcrumb="Tutorial Upload" hideUploadButton>
      <UploaderNav />

      <div className="row about-upload">
        <div className="col-12 col-md-7 col-xl-6 text-default upload__guidelines">
          <h1 className="section__title">New Tutorial</h1>
          <p>
            Share your knowledge and skills with other members at CGTrader. Your tutorial will be shown in your
            profile under the ‘Tutorials’ tab. Exceptional tutorials might be promoted through the Seller’s Dashboard.
          </p>
          <div className="list-heading">Before you go ahead:</div>
          <ul className="list">
            <li>Give your tutorial a clear and simple name.</li>
            <li>Make sure that your tutorial brings something new and valuable to the community.</li>
            <li>Remember, you can select several software applications and categories for the tutorial.</li>
            <li>Embed YouTube videos, images, screenshots and other media in your tutorial.</li>
          </ul>
          <a href="/tutorials/new" className="btn btn-primary btn-fat btn-upload">Upload tutorial</a>
        </div>

        <div className="col-12 col-md-5 offset-xl-1 hero-image">
          <img src={TutorialPage} alt="Tutorial page" />
        </div>
      </div>
    </Layout>
  )
}

export default TutorialUploader
